<h1>Albion Online Market And Black Market Flipper</h1>
<!-- MARK: Entitlements -->
<div class="entitlements">
  @if (userSettingsService.isLoggedIn$ | async) {
    @if (afmBeService.userHasMasterpieceEntitlement()) {
      <p>As a Masterpiece Supporter, you have unlimited access to the Albion Free Market Flipper. Thank you for supporting the project!</p>
    } @else if (afmBeService.userHasOutstandingEntitlement()) {
      <p>As an Outstanding Supporter, you can see all flips up to {{ SUB_LIMITS.flipper.outstanding | smallNumber }} profit. Thank you for supporting the project!</p>
      <p>If you want to change your supporter level, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    } @else if (afmBeService.userHasNormalEntitlement()) {
      <p>As a Normal Supporter, you can see all flips up to {{ SUB_LIMITS.flipper.normal | smallNumber }} profit. Thank you for supporting the project!</p>
      <p>If you want to change your supporter level, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    } @else {
      <p>Since you are not a supporter of Albion Free Market, you can only see flips up to {{ SUB_LIMITS.flipper.default | smallNumber }} profit.</p>
      <p>If you want to become a supporter, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    }
    <p>
      @if (flipperStateService.missedFlipsCount() > 0 && flipperStateService.missedFlipsProfit() > 0) {
        You have missed {{ flipperStateService.missedFlipsCount() | number: '1.0-0' }} flips. They are worth {{ flipperStateService.missedFlipsProfit() | smallNumber }}
        silver. Become a supporter to see them all.
      }
    </p>
  } @else {
    <div>
      You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
    </div>
  }
</div>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" animationDuration="100">
  <mat-tab label="Intro">
    <ng-template matTabContent>
      <app-flipper-intro></app-flipper-intro>
    </ng-template>
  </mat-tab>
  <mat-tab label="Statistics">
    <ng-template matTabContent>
      <app-flipper-stats></app-flipper-stats>
    </ng-template>
  </mat-tab>
  <mat-tab label="Upgrades" [disabled]="!(authService.user$ | async)">
    <ng-template matTabContent>
      <app-flipper-settings></app-flipper-settings>
    </ng-template>
  </mat-tab>
  <mat-tab label="Find Flips" [disabled]="!(authService.user$ | async)">
    @defer (on viewport) {
      <app-flipper-flips></app-flipper-flips>
    } @placeholder {
      <p>Loading flips...</p>
    }
  </mat-tab>
  <mat-tab label="Session Flips" [disabled]="!(authService.user$ | async)">
    <ng-template matTabContent>
      <app-flipper-session-flips></app-flipper-session-flips>
    </ng-template>
  </mat-tab>
</mat-tab-group>
